import * as React from 'react';

function SvgStrategy(props) {
  return (
    <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#strategy_svg__clip0_68_4522)">
        <path d="M14.504 3.783V1.531a.562.562 0 00-.562-.562H2.059a.562.562 0 00-.563.562v2.252a.562.562 0 00-.527.56V6.66a3.111 3.111 0 00.527 1.745v6.065c0 .31.252.562.563.562h4.816v-3.094h2.25v3.094h4.817a.562.562 0 00.562-.562V8.404a3.142 3.142 0 00.527-1.746V4.345a.562.562 0 00-.527-.561zm-1.265 9.984H10.25v-2.392a.562.562 0 00-.562-.563H6.313a.562.562 0 00-.563.563v2.392H2.762V9.51a3.168 3.168 0 001.396.318 3.175 3.175 0 001.917-.636.011.011 0 01.011 0c.21.157.438.287.68.388.392.166.809.248 1.238.248a3.175 3.175 0 001.918-.636.011.011 0 01.01 0c.21.157.438.287.68.388.392.166.809.248 1.238.248a3.175 3.175 0 001.396-.318v4.257h-.008zm0-9.986H2.761V2.234h10.476v1.547z" />
      </g>
      <defs>
        <clipPath id="strategy_svg__clip0_68_4522">
          <path fill="#fff" d="M0 0h16v16H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default SvgStrategy;
